module.exports = __webpack_public_path__ + "img/portfolio-mha-new.1189e809.jpg";